import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Clientes from './components/clientes/Clientes';
import NuevoPrestamo from './components/Prestamos/NuevoPrestamo';
import PrestamosActivos from './components/Prestamos/PrestamosActivos';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import DetallePrestamo from './components/Prestamos/DetallePrestamo';
import Gastos from './components/gastos/Gastos';
import {AuthProvider} from '../src/components/context/AuthProvider'
import RutaProtegida from './components/layout/RutaProtegida';
import AuthLayout from './components/layout/AuthLayout'
import Home from './components/Home';
import InformePrestamos from './components/informes/InformePrestamos';
import PrestamosFinalizados from './components/Prestamos/PrestamosFinalizados';
//Rutas para el login
import Login from './components/login/login';
import Registrar from './components/login/Registrar';
import OlvidePassword from './components/login/OlvidePassword';
import NuevoPassword from './components/login/NuevoPassword';
import confirmarCuenta from './components/login/ConfirmarCuenta';
import InformeGastos from './components/informes/InformeGastos';
import Productos from './components/productos/Productos';
import NuevaVenta from './components/ventas/NuevaVenta';
import HistorialVentas from './components/ventas/HistorialVentas';
import VentasEnCurso from './components/ventas/VentasEnCurso';
import ProximosVencimientos from './components/Prestamos/ProximosVencimientos';
import DetalleVenta from './components/ventas/DetalleVenta';
import InformeVentas from './components/informes/InformeVentas';
import ProximosVencimientosVentas from './components/ventas/ProximosVencimientosVentas';
import GananciaReal from './components/informes/GananciaReal';
import MediosPago from './components/informes/MediosPago';
import InformeVentasActivas from './components/informes/InformeVentasActivas';
import GeneradorConsulta from './components/generadorconsulta/GeneradorConsulta';
import SupervisorPagos from './components/generadorconsulta/SupervisorPagos';
import ClienteDashboard from './components/clientes/DashboardCliente';
import ClientesAnalytics from './components/clientes/ClientesAnalytics';

function App() {

  return (
    <div className="App"  style= {{background: "#eeeeee"}}>
      <BrowserRouter>
      <AuthProvider>
        <div>
          <Routes>
            <Route exact path='/' caseSensitive={false} element={<AuthLayout />}>
              <Route index element={<Login />} />
              <Route exact path='registrar' caseSensitive={false} element={<Registrar />} />
              <Route exact path='olvide-password' caseSensitive={false} element={<OlvidePassword />} />
              <Route exact path='olvide-password/:token' caseSensitive={false} element={<NuevoPassword />} />
              <Route exact path='confirmar/:id' caseSensitive={false} element={<confirmarCuenta />} />
            </Route>

            <Route path="/prestamos" element={<RutaProtegida />}>
              <Route index element={<Home />} />
              <Route exact path='clientes' caseSensitive={false} element={<Clientes />} />
              <Route exact path='NuevoPrestamo' caseSensitive={false} element={<NuevoPrestamo />} />
              <Route exact path='PrestamosActivos/NuevoPrestamo' caseSensitive={false} element={<NuevoPrestamo />} />
              <Route exact path='PrestamosActivos' caseSensitive={false} element={<PrestamosActivos />} />
              <Route exact path='PrestamosFinalizados' caseSensitive={false} element={<PrestamosFinalizados />} />
              <Route exact path='PrestamosActivos/DetallePrestamo/:IdPrestamo' caseSensitive={false} element={<DetallePrestamo />} />
              <Route exact path='VentasEnCurso/DetalleVenta/:IdVenta' caseSensitive={false} element={<DetalleVenta />} />
              <Route exact path='prestamos/VentasEnCurso/DetalleVenta/:IdVenta' caseSensitive={false} element={<DetalleVenta />} />
              
              <Route exact path='PrestamosFinalizados/DetallePrestamo/:IdPrestamo' caseSensitive={false} element={<DetallePrestamo />} />
              <Route exact path='prestamos/NuevoPrestamo/DetallePrestamo/:IdPrestamo' caseSensitive={false} element={<DetallePrestamo />} />
              <Route exact path='NuevoPrestamo/DetallePrestamo/:IdPrestamo' caseSensitive={false} element={<DetallePrestamo />} />
              <Route exact path='prestamos/PrestamosActivos/NuevoPrestamo/DetallePrestamo/:IdPrestamo' caseSensitive={false} element={<DetallePrestamo />} />
              <Route exact path='prestamos/PrestamosFinalizados/NuevoPrestamo/DetallePrestamo/:IdPrestamo' caseSensitive={false} element={<DetallePrestamo />} />
              <Route exact path='Gastos' caseSensitive={false} element={<Gastos />} />  
              <Route exact path='Productos' caseSensitive={false} element={<Productos />} />  
              <Route exact path='NuevaVenta' caseSensitive={false} element={<NuevaVenta />} />  
              <Route exact path='HistorialVentas' caseSensitive={false} element={<HistorialVentas />} />  
              <Route exact path='VentasEnCurso' caseSensitive={false} element={<VentasEnCurso />} />
             <Route exact path='prestamos/VentasEnCurso/NuevaVenta' caseSensitive={false} element={<NuevaVenta />} />  
              <Route exact path='VentasEnCurso/NuevaVenta' caseSensitive={false} element={<NuevaVenta />} />  
              
              <Route exact path='prestamos/NuevaVenta/HistorialVentas' caseSensitive={false} element={<HistorialVentas />} />
              
              <Route exact path='NuevaVenta/HistorialVentas' caseSensitive={false} element={<HistorialVentas />} />
              <Route exact path='NuevaVenta/DetalleVenta/:IdVenta' caseSensitive={false} element={<DetalleVenta />} />
              <Route exact path='prestamos/NuevaVenta/DetalleVenta/:IdVenta' caseSensitive={false} element={<DetalleVenta />} />
             

             
              <Route exact path='InformeGastos' caseSensitive={false} element={<InformeGastos />} /> 
              <Route exact path='MediosPago' caseSensitive={false} element={<MediosPago />} /> 
              <Route exact path='InformePrestamos' caseSensitive={false} element={<InformePrestamos />} />  
              <Route exact path='InformeVentas' caseSensitive={false} element={<InformeVentas />} />
              <Route exact path='InformeVentasActivas' caseSensitive={false} element={<InformeVentasActivas />} />  
              <Route exact path='GananciaReal' caseSensitive={false} element={<GananciaReal />} />  
              <Route exact path='ProximosVencimientos' caseSensitive={false} element={<ProximosVencimientos />} /> 
              <Route exact path='ProximosVencimientosVentas' caseSensitive={false} element={<ProximosVencimientosVentas />} />  
              
              <Route exact path='GeneradorConsulta' caseSensitive={false} element={<GeneradorConsulta />} /> <Route exact path='GeneradorConsulta' caseSensitive={false} element={<GeneradorConsulta />} />
                <Route exact path='SupervisorPagos' caseSensitive={false} element={<SupervisorPagos />} /> <Route exact path='GeneradorConsulta' caseSensitive={false} element={<GeneradorConsulta />} />
               <Route exact path='ResumenCliente' caseSensitive={false} element={<ClienteDashboard />} /> <Route exact path='ResumenCliente' caseSensitive={false} element={<ClienteDashboard />} />
             <Route exact path='AnalisisClientes' caseSensitive={false} element={<ClientesAnalytics />} /> <Route exact path='AnalisisClientes' caseSensitive={false} element={<ClientesAnalytics />} />
            
            </Route>
         
          </Routes>
        </div>
        </AuthProvider>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
